import CheckIcon from '@mui/icons-material/Check';
import EmailIcon from '@mui/icons-material/Email';
import {
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineSeparator,
} from '@mui/lab';
import { Button, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import UserEmailSettings from '../Settings/UserEmailSettings/UserEmailSettings';

interface Props {
    userEmailId: string | undefined;
}

export function UserEmailTimelineItem({ userEmailId }: Props) {
    const [showSetupEmail, setShowSetupEmail] = useState(false);

    const handleShowChangeEmail = () => {
        setShowSetupEmail(true);
    };

    const hasUserEmail = !!userEmailId;

    return (
        <TimelineItem>
            <TimelineSeparator>
                <TimelineDot color={hasUserEmail ? 'success' : undefined}>
                    {!hasUserEmail ? <EmailIcon /> : <CheckIcon />}
                </TimelineDot>
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ display: 'flex', flexDirection: 'column' }}>
                <Grid container flexDirection="column" spacing={2}>
                    <Grid item>
                        <Typography variant="h5">Connect your Email</Typography>
                    </Grid>
                    <Grid item>
                        <Typography color={'text.secondary'}>
                            Setting up an email address in StayInContact enhances your connectivity,
                            enabling you to send and receive emails directly within the interface.
                            This integration streamlines your communication, consolidating multiple
                            channels into one easy-to-manage platform.
                        </Typography>
                    </Grid>
                    {!showSetupEmail && (
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleShowChangeEmail}
                                disabled={hasUserEmail}
                            >
                                Setup Email
                            </Button>
                        </Grid>
                    )}
                    {showSetupEmail && (
                        <Grid item>
                            <UserEmailSettings />
                        </Grid>
                    )}
                </Grid>
            </TimelineContent>
        </TimelineItem>
    );
}
